<template>
  <div class="root">
    <!-- 轮播 -->
    <div class="model1" ref="carousel1">
      <div class="carousel" @mouseenter="showButtons = true" @mouseleave="showButtons = false">
        <div class="carousel-container">
          <div class="carousel-item" v-for="(item, index) in slidePhotoList" :key="index"
            :class="{ 'active': currentIndex === index }">
            <img v-lazy="item.photo" />
          </div>
        </div>
        <div class="carousel-indicators">
          <span v-for="(item, index) in slidePhotoList" :key="index" :class="{ 'active': currentIndex === index }"
            @click="goTo(index)"></span>
        </div>
      </div>
      <div class="model1_text" @click="goToAbout">
        <div>
          <div>以科技重塑健康</div>
          <div>用创新定义未来</div>
        </div>
        <div class="mouseCursor  learnBtn">
          <span>了解更多</span>
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </div>
    <!-- 精英团队 -->
    <div class="model2" ref="carousel2">
      <div class="model_title">
        <div class="backAnima">
          <div>精英团队</div>
        </div>
        <div class="carousel_style computerShow_btn">
          <div class="carousel-button2 prev2" @click="prev2_team">
            <i class="el-icon-back"></i>
          </div>
          <div class="carousel-button2 next2" @click="next2_team">
            <i class="el-icon-right"></i>
          </div>
        </div>
        <div class="carousel_style phoneShow_btn">
          <div class="carousel-button2 prev2" @click="prev2">
            <i class="el-icon-back"></i>
          </div>
          <div class="carousel-button2 next2" @click="next2">
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
      <div class="computerShow">
        <div class="team_slideShow">
          <div class="team_slideShow_item">
            <div v-for="(item, index_team) in currentItems" :key="index_team" class="team_slideShow_item_content"
              :class="{ 'active_team': (index_team === 2) }">
              <!-- <img :src="item.memberPhoto" loading="lazy" /> -->

              <img v-lazy="item.memberPhoto" />
              <div class="team_slideShow_item_title">{{ item.memberName }}</div>
            </div>
          </div>
        </div>

        <!-- <el-carousel :interval="4000" type="card" height="20vw">
          <el-carousel-item v-for="(item,index) in teamList" :key="index">
            <img :src="item.memberPhoto" loading="lazy" />
          </el-carousel-item>
        </el-carousel> -->
      </div>

      <div class="phoneShow" @click="goToTeam">
        <div class="carouse">
          <div class="carousel-container">
            <div class="carousel-item_phone_team" v-for="(item, index2) in teamList" :key="index2"
              :class="{ 'active': currentIndex2 === index2 }">
              <img :src="item.memberPhoto" loading="lazy" />
              <div class="team_title">{{item.memberName}}</div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- 产品中心 -->
    <div class="model3">
      <div class="model_title">
        <div class="backAnima">
          <div>产品中心</div>
        </div>
      </div>
      <div class="computerShow">
        <div class="pro_computer mouseCursor">
          <div @mouseenter="showBackground" @mouseleave="hideBackground" :class="{'hover-pro': isHovered}"
            @click="goToProduct(pro1.productKindId)">
            <div :style="backgroundStyle" class="proImg"></div>
            <div class="pro_computer_title pro_computer_title1">{{pro1.productKind}}</div>
            <div class="pro_computer_learnBtn pro_computer_learnBtn1">了解更多</div>
          </div>
          <div @mouseenter="showBackground2" @mouseleave="hideBackground2" :class="{'hover-pro': isHovered2}"
            @click="goToProduct(pro2.productKindId)">
            <div :style="backgroundStyle2" class="proImg"></div>
            <div class="pro_computer_title pro_computer_title2">{{pro2.productKind}}</div>
            <div class="pro_computer_learnBtn pro_computer_learnBtn2">了解更多</div>
          </div>
          <div @mouseenter="showBackground3" @mouseleave="hideBackground3" :class="{'hover-pro': isHovered3}"
            @click="goToProduct(pro3.productKindId)">

            <div :style="backgroundStyle3" class="proImg"></div>
            <div class="pro_computer_title pro_computer_title3">{{pro3.productKind}}</div>
            <div class="pro_computer_learnBtn pro_computer_learnBtn3">了解更多</div>
          </div>
        </div>

        <div class="pro_computer2 mouseCursor">
          <div @mouseenter="showBackground4" @mouseleave="hideBackground4" :class="{'hover-pro': isHovered4}"
            @click="goToProduct(pro4.productKindId)">

            <div :style="backgroundStyle4" class="proImg"></div>
            <div class="pro_computer_title pro_computer_title4">{{pro4.productKind}}</div>
            <div class="pro_computer_learnBtn pro_computer_learnBtn4">了解更多</div>
          </div>
          <div @mouseenter="showBackground5" @mouseleave="hideBackground5" :class="{'hover-pro': isHovered5}"
            @click="goToProduct(pro5.productKindId)">
            <div :style="backgroundStyle5" class="proImg"></div>
            <div class="pro_computer_title pro_computer_title5">{{pro5.productKind}}</div>
            <div class="pro_computer_learnBtn pro_computer_learnBtn5">了解更多</div>
          </div>
          <div @click="goToProduct()">
            <div class="pro_computer_title">更多用药</div>
          </div>
        </div>
      </div>
      <div class="phoneShow">
        <div class="pro_phoneList">
          <div class="pro_phoneList_item" @click="goToProduct(pro1.productKindId)">
            <div class="pro_phoneList_item_img">
              <img :src="pro1.productPhoto" loading="lazy" />
            </div>
            <div class="pro_phoneList_item_text">
              <div>{{pro1.productKind}}</div>
              <div>了解更多</div>
            </div>
          </div>
          <div class="pro_phoneList_item" @click="goToProduct(pro2.productKindId)">
            <div class="pro_phoneList_item_img">
              <img :src="pro2.productPhoto" loading="lazy" />
            </div>
            <div class="pro_phoneList_item_text">
              <div>{{pro2.productKind}}</div>
              <div>了解更多</div>
            </div>
          </div>
          <div class="pro_phoneList_item" @click="goToProduct(pro3.productKindId)">
            <div class="pro_phoneList_item_img">
              <img :src="pro3.productPhoto" loading="lazy" />
            </div>
            <div class="pro_phoneList_item_text">
              <div>{{pro3.productKind}}</div>
              <div>了解更多</div>
            </div>
          </div>
          <div class="pro_phoneList_item" @click="goToProduct(pro4.productKindId)">
            <div class="pro_phoneList_item_img">
              <img :src="pro4.productPhoto" loading="lazy" />
            </div>
            <div class="pro_phoneList_item_text">
              <div>{{pro4.productKind}}</div>
              <div>了解更多</div>
            </div>
          </div>
          <div class="pro_phoneList_item" @click="goToProduct(pro5.productKindId)">
            <div class="pro_phoneList_item_img">
              <img :src="pro5.productPhoto" loading="lazy" />
            </div>
            <div class="pro_phoneList_item_text">
              <div>{{pro5.productKind}}</div>
              <div>了解更多</div>
            </div>
          </div>
          <div class="pro_phoneList_item" @click="goToProduct()">
            <div>更多用药</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 荣誉资质 -->
    <div class="model4" ref="carousel3">
      <div class="model_title">
        <div class="backAnima">
          <div>荣誉资质</div>
        </div>
      </div>
      <div class="computerShow">
        <div class="carousel_honor">
          <!--  @mouseleave="startCarousel_honor" -->
          <div class="carousel_honorStyle" @click="goToAbout">
            <!-- 渲染轮播图 -->
            <div class="carousel_item_honor" v-for="(item, index3) in currentGroup" :key="index3">
              <img :src="item.honorPhoto" loading="lazy" />
              <div class="honorText">{{item.honorText}}</div>
            </div>
          </div>
          <!-- 左右按钮 -->
          <button class="prev" @click="prevGroup">
            <i class="el-icon-arrow-left"></i>
          </button>
          <button class="next" @click="nextGroup">
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>



      </div>
      <div class="phoneShow model4_phoneShow">
        <!-- 上一页按钮 -->
        <div class="carousel-button3" @click="prev3">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="carouse" style="width: 50%;" @click="goToAbout">
          <div class="carousel-container">
            <div class="carousel-item_phone_honor" v-for="(item, index3) in honorList" :key="index3"
              :class="{ 'active': currentIndex3 === index3 }">
              <img :src="item.honorPhoto" loading="lazy" />
              <div class="honorText">{{item.honorText}}</div>
            </div>
          </div>
        </div>
        <!-- 下一页按钮 -->
        <div class="carousel-button3" @click="next3">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <!-- 新闻动态 -->
    <div class="model5">
      <div class="model_title">
        <div class="backAnima">
          <div>新闻动态</div>
        </div>
      </div>
      <div class="computerShow mouseCursor" @click="goNew">
        <div v-if="newsList.length>0">
          <!-- :style="{ backgroundImage: 'url(' + getBackgroundImage(newsList[0].newsPhoto) + ')', backgroundSize: 'cover'}" -->
          <img :src="getBackgroundImage(newsList[0].newsPhoto)" loading="lazy" class="newImg_com" />
          <div class="new_com">
            <div>
              {{newsList[0].newsTitle}}
            </div>
            <span> {{formatDate(newsList[0].dateTime)}}</span>
          </div>
        </div>
        <div v-if="newsList.length>0">
          <img :src="getBackgroundImage(newsList[1].newsPhoto)" loading="lazy" class="newImg_com" />
          <div class="new_com">
            <div>
              {{newsList[1].newsTitle}}
            </div>
            <span> {{formatDate(newsList[1].dateTime)}}</span>
          </div>
        </div>
        <div>
          <div v-if="newsList.length>0">
            <img :src="getBackgroundImage(newsList[2].newsPhoto)" loading="lazy" class="newImg_com" />
            <div class="new_com">
              <div>
                {{newsList[2].newsTitle}}
              </div>
              <span> {{formatDate(newsList[2].dateTime)}}</span>
            </div>
          </div>
          <div v-if="newsList.length>0">
            <img :src="getBackgroundImage(newsList[3].newsPhoto)" loading="lazy" class="newImg_com" />
            <div class="new_com">
              <div>
                {{newsList[3].newsTitle}}
              </div>
              <span> {{formatDate(newsList[3].dateTime)}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="phoneShow new_phoneShow" @click="goNew">
        <div v-for="(item, new_index) in newsList.slice(0, 4)" :key="new_index" class="new_model">
          <img :src="item.newsPhoto.includes(',') ? item.newsPhoto.split(',')[0] : item.newsPhoto" loading="lazy" />
          <div class="newText">
            <div>{{item.newsTitle}}</div>
          </div>
          <div class="newTime">
            <div v-if="newsList.length>0">{{formatDate(item.dateTime)}}</div>
          </div>
          <!-- <img src="../components/slideShow.vue"/> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import dayjs from 'dayjs';
  import axios from '@/utils/request.js';
  import { getSlidePhoto } from '@/utils/request.js';
  import { getAllMember } from '@/utils/request.js';
  import { getAllProKind } from '@/utils/request.js';
  import { getAllNews } from '@/utils/request.js';

  export default {
    data() {
      return {
        slidePhotoList: [],
        teamList: [],
        currentIndex_team: 0,
        currentItems: [],
        autoPlayInterval_team: null,
        proKindList: [],
        honorList: [],

        newsList: [],
        pro1: [],
        isHovered: false,
        backgroundStyle: {},
        pro2: [],
        isHovered2: false,
        backgroundStyle2: {},
        pro3: [],
        isHovered3: false,
        backgroundStyle3: {},
        pro4: [],
        isHovered4: false,
        backgroundStyle4: {},
        pro5: [],
        isHovered5: false,
        backgroundStyle5: {},
        searchText: '',
        currentIndex: 0,
        currentIndex2: 0,
        currentIndex3: 0,//荣誉资质
        currentIndex_honor: 0,
        autoPlayInterval: null,
        autoPlayInterval2: null,
        autoPlayInterval3: null,
        autoPlayInterval_honor: null,
        interval_honor: 3000, // 自动播放间隔
        timer_honor: null, // 定时器
        transitioning: false,  // 判断是否正在过渡，防止用户在过渡期间重复点击
        showButtons: false,// 控制按钮显示和隐藏
        // 控制轮播的标志
        isCarousel1InView: false,
        isCarousel2InView: false,
        isCarousel3InView: false,
      }
    },

    computed: {  // 获取当前展示的图片组，每组 5 个图片
      currentGroup() {
        const startIndex = this.currentIndex_honor * 5;
        return this.honorList.slice(startIndex, startIndex + 5);
      },
      // 轮播图的偏移效果
      // carouselStyle() {
      //   const offset = -(this.currentIndex_honor * 100/50); // 计算偏移量
      //   console.log("offset",offset);
      //   return {
      //     transform: `translateX(${offset}%)`,
      //     transition: 'transform 0.5s ease',
      //   };
      // }
      //   backgroundStyle_new1() {
      //   return {
      //     backgroundImage: `url(${this.newsList[0].newsPhoto})`,
      //     backgroundSize: 'cover', // 背景图覆盖整个容器
      //     backgroundPosition: 'center', // 背景图居中
      //     // height: '300px', // 设置高度
      //   };
      // },
      //   backgroundStyle_new2() {
      //   return {
      //     backgroundImage: `url(${this.newsList[1].newsPhoto})`,
      //     backgroundSize: 'cover', // 背景图覆盖整个容器
      //     backgroundPosition: 'center', // 背景图居中
      //     // height: '300px', // 设置高度
      //   };
      // },
    },
    created() { },
    mounted() {
      this.getSlidePhoto();
      this.startAutoPlay();
      // this.observeVisibility(); // 在组件挂载时开始监听视图进入
      this.executeMethods();
      // this.startCarousel_honor();
      console.log(this.newsList);
    },
    beforeDestroy() {
      // 在组件销毁之前停止观察，避免内存泄漏
      // if (this.observer) {
      //   this.observer.disconnect();
      // }
    },
    // 方法体
    methods: {
      getBackgroundImage(photo) {
        // 如果有逗号，返回逗号前的部分，否则返回完整的 photo
        return photo.split(',')[0] || photo;
      },
      // 下一组
      nextGroup() {
        if (this.currentIndex_honor < Math.ceil(this.honorList.length / 5) - 1) {
          this.currentIndex_honor++;
        } else {
          this.currentIndex_honor = 0; // 如果到达最后一组，循环回到第一组
        }
      },
      // 上一组
      prevGroup() {
        if (this.currentIndex_honor > 0) {
          this.currentIndex_honor--;
        } else {
          this.currentIndex_honor = Math.ceil(this.honorList.length / 5) - 1; // 如果到达第一组，循环回到最后一组
        }
      },
      // 开始自动播放
      startCarousel_honor() {
        this.autoPlayInterval_honor = setInterval(() => {
          this.nextGroup();
        }, 3000); // 每3秒轮播一次
      },
      // startCarousel_team() {

      // },
      // 停止自动播放
      stopAutoPlay_honor() {
        clearInterval(this.timtimer_honorer);
      },










      startCarousel_team() {
        this.autoPlayInterval_team = setInterval(() => {
          this.next2_team();
        }, 3000); // 每3秒轮播一次
      },
      async updateCarousel() {
        // 更新显示的项目
        this.currentItems = [
          this.teamList[(this.currentIndex_team + this.teamList.length - 2) % this.teamList.length],
          this.teamList[(this.currentIndex_team + this.teamList.length - 1) % this.teamList.length],
          this.teamList[this.currentIndex_team],
          this.teamList[(this.currentIndex_team + 1) % this.teamList.length],
          this.teamList[(this.currentIndex_team + 2) % this.teamList.length],
        ];
        // this.currentIndex_team = (this.currentIndex_team + 1) % this.teamList.length;
      },
      showBackground() {
        this.isHovered = true;
        this.backgroundStyle = {
          backgroundImage: `url(${this.pro1.productPhoto})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      },
      showBackground2() {
        this.isHovered2 = true;
        this.backgroundStyle2 = {
          backgroundImage: `url(${this.pro2.productPhoto})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      },
      showBackground3() {
        this.isHovered3 = true;
        this.backgroundStyle3 = {
          backgroundImage: `url(${this.pro3.productPhoto})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      },
      showBackground4() {
        this.isHovered4 = true;
        this.backgroundStyle4 = {
          backgroundImage: `url(${this.pro4.productPhoto})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      },
      showBackground5() {
        this.isHovered5 = true;
        this.backgroundStyle5 = {
          backgroundImage: `url(${this.pro5.productPhoto})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      },
      hideBackground() {
        this.backgroundStyle = {};  // 鼠标离开时清除背景图 
        this.isHovered = false;
      },
      hideBackground2() {
        this.backgroundStyle2 = {};  // 鼠标离开时清除背景图 
        this.isHovered2 = false;
      },
      hideBackground3() {
        this.backgroundStyle3 = {};  // 鼠标离开时清除背景图 
        this.isHovered3 = false;
      },
      hideBackground4() {
        this.backgroundStyle4 = {};  // 鼠标离开时清除背景图 
        this.isHovered4 = false;
      },
      hideBackground5() {
        this.backgroundStyle5 = {};  // 鼠标离开时清除背景图 
        this.isHovered5 = false;
      },


      async executeMethods() {
        // await this.getSlidePhoto();
        await this.showAllMember();
        await this.startCarousel_team(); // 在组件挂载时启动自动轮播
        this.startAutoPlay2();
        await this.showAllProKind();
        await this.showPro1();
        await this.showPro2();
        await this.showPro3();
        await this.showPro4();
        await this.showPro5();
        await this.showHonorList();
        this.startCarousel_honor();
        this.startAutoPlay3(); // 在视口内时开始轮播
        await this.showNewsList();
      },
      // 监听轮播视图进入视口
      // observeVisibility() {
      //   const options = {
      //     root: null, // 默认是浏览器视窗
      //     rootMargin: '0px', // 不偏移
      //     threshold: 0.5 // 当目标元素有50%在视口中时触发
      //   };

      //   const observer = new IntersectionObserver((entries) => {
      //     entries.forEach(entry => {
      //       const target = entry.target;
      //       if (entry.isIntersecting) {
      //         if (target === this.$refs.carousel1) {
      //           this.isCarousel1InView = true;
      //           this.startAutoPlay(); // 在视口内时开始轮播
      //         } else
      //           if (target === this.$refs.carousel2) {
      //             this.isCarousel2InView = true;
      //             this.startAutoPlay2(); // 在视口内时开始轮播
      //           } else if (target === this.$refs.carousel3) {
      //             this.isCarousel3InView = true;
      //             this.startAutoPlay3(); // 在视口内时开始轮播
      //             this.startCarousel_honor();
      //           }
      //       } else {
      //         if (target === this.$refs.carousel1) {
      //           this.isCarousel1InView = false;
      //         } else if (target === this.$refs.carousel2) {
      //           this.isCarousel2InView = false;
      //         } else if (target === this.$refs.carousel3) {
      //           this.isCarousel3InView = false;
      //         }
      //       }
      //     });
      //   }, options);

      //   // 观察每个轮播
      //   observer.observe(this.$refs.carousel1);
      //   observer.observe(this.$refs.carousel2);
      //   observer.observe(this.$refs.carousel3);
      // },
      async getSlidePhoto() {
        try {
          const response = await getSlidePhoto();
          if (response.code === 200) {
            this.slidePhotoList = response.data;
          } else {
            console.error('Failed to fetch departments:', response.msg);
          }
        } catch (error) {
          console.error('Error fetching departments:', error);
        }
        return new Promise(resolve => setTimeout(resolve, 1000));
      },
      async showAllMember() {
        try {
          const response = await getAllMember();
          if (response.code === 200) {
            this.teamList = response.data.map(section => ({
              ...section,
              expanded: false,// 添加expanded属性，默认为false
            }));// 仅在加载完成后手动调用 updateCarousel，确保首次渲染时正确显示
            if (this.teamList.length > 0) {
              this.updateCarousel(); // 初始化轮播
            }
          } else {
            console.error('Failed to fetch departments:', response.msg);
          }
        } catch (error) {
          console.error('Error fetching departments:', error);
        }
      },
      async showAllProKind() {
        try {
          const response = await getAllProKind();
          if (response.code === 200) {
            this.proKindList = response.data;
          } else {
            console.error('Failed to fetch departments:', response.msg);
          }
        } catch (error) {
          console.error('Error fetching departments:', error);
        }
      },
      async showHonorList() {
        const url = `/showHonor?honorText=${encodeURIComponent(this.searchText)}&limit=${999999999}&offset=${0}`;
        axios.get(url)
          .then(response => {
            this.honorList = response.data;
          })
          .catch(error => {
            this.$message("失败");
          });
      },
      async showNewsList() {
        try {
          const response = await getAllNews();
          if (response.code === 200) {
            this.newsList = response.data;
            console.log("xinwen", this.newsList[0]);
          } else {
            console.error('Failed to fetch departments:', response.msg);
          }
        } catch (error) {
          console.error('Error fetching departments:', error);
        }
      },
      async showPro1() {
        const url = `/showOneProductKind?productKindId=${this.proKindList[0].productKindId}`;
        axios.get(url)
          .then(response => {
            this.pro1 = response.data[0];
          })
          .catch(error => {
            this.$message("失败");
          });
      },
      async showPro2() {
        const url = `/showOneProductKind?productKindId=${this.proKindList[1].productKindId}`;
        axios.get(url)
          .then(response => {
            this.pro2 = response.data[0];
          })
          .catch(error => {
            this.$message("失败");
          });
      },
      async showPro3() {
        const url = `/showOneProductKind?productKindId=${this.proKindList[2].productKindId}`;
        axios.get(url)
          .then(response => {
            this.pro3 = response.data[0];
          })
          .catch(error => {
            this.$message("失败");
          });
      },
      async showPro4() {
        const url = `/showOneProductKind?productKindId=${this.proKindList[3].productKindId}`;
        axios.get(url)
          .then(response => {
            this.pro4 = response.data[0];
          })
          .catch(error => {
            this.$message("失败");
          });
      },
      async showPro5() {
        const url = `/showOneProductKind?productKindId=${this.proKindList[4].productKindId}`;
        axios.get(url)
          .then(response => {
            this.pro5 = response.data[0];
          })
          .catch(error => {
            this.$message("失败");
          });
      },
      goTo(index) {
        this.currentIndex = index;
      },
      next() {
        this.currentIndex = (this.currentIndex + 1) % this.slidePhotoList.length;
      },
      prev() {
        this.currentIndex = (this.currentIndex - 1 + this.slidePhotoList.length) % this.slidePhotoList.length;
      },
      next2() {
        this.currentIndex2 = (this.currentIndex2 + 1) % this.teamList.length;
      },
      prev2() {
        this.currentIndex2 = (this.currentIndex2 - 1 + this.teamList.length) % this.teamList.length;
      },
      next2_team() {
        this.currentIndex_team = (this.currentIndex_team + 1) % this.teamList.length;
        this.updateCarousel(); // 更新轮播图显示
      },
      prev2_team() {
        this.currentIndex_team = (this.currentIndex_team - 1 + this.teamList.length) % this.teamList.length;
        this.updateCarousel(); // 更新轮播图显示
      },
      next3() {
        this.currentIndex3 = (this.currentIndex3 + 1) % this.honorList.length;
      },
      prev3() {
        this.currentIndex3 = (this.currentIndex3 - 1 + this.honorList.length) % this.honorList.length;
      },
      startAutoPlay() {
        this.autoPlayInterval = setInterval(() => {
          this.next();
        }, 3000);
      },
      startAutoPlay2() {
        this.autoPlayInterval2 = setInterval(() => {
          this.next2();
        }, 3000);
      },
      startAutoPlay3() {
        this.autoPlayInterval3 = setInterval(() => {
          this.next3();
        }, 3000);
      },
      stopAutoPlay2() {
        clearInterval(this.autoPlayInterval2);
      },
      goToAbout() {
        this.$router.push('/about');
      },
      goToTeam() {
        this.$router.push('/team');
      },
      formatDate(dateStr) {
        // 使用 dayjs 格式化日期
        return dayjs(dateStr).format('YYYY/MM/DD');
      },

      goToProduct(productKindId) {
        this.$router.push({
          path: '/products',
          query: { productKindId } // 通过 query 传递参数
        });
      },

      goNew() {
        this.$router.push('/news');
      }
    },

  }
</script>
<style scoped>
  .model1 {
    position: relative;
  }

  .model1_text {
    position: absolute;
    bottom: 10vw;
    left: 8vw;
    font-size: 1.8vw;
    color: white;
    font-weight: 600;
  }

  .model1_text>div:nth-child(1) {
    margin-bottom: 2.3vw;
  }

  .model1_text>div:nth-child(1)>div:nth-child(1) {
    margin-bottom: 0.5vw;
  }

  .model1_text>div:nth-child(2) {
    font-size: 1vw;
    border: 1px solid white;
    padding: 0.6vw 0vw;
    border-radius: 3vw;
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .model1_text>div:nth-child(2)>span {
    margin-right: 0.5vw;
  }

  .model1_text>div:nth-child(2)>i {
    font-size: 0.8vw;
  }

  .carousel {
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  .carousel-container {
    display: flex;
    transition: transform 0.5s ease;
  }

  .carousel-item {
    min-width: 100%;
    display: none;
    height: 45vw;
  }

  .carousel-item_phone_honor {
    width: 50%;
    display: none;
    height: 30vw;
    margin: auto;
    position: relative;
  }

  .carousel-item_phone_team {
    width: 50%;
    display: none;
    height: 30vw;
    margin: auto;
    position: relative;
  }

  .carousel-item_phone_honor.active {
    display: block;
  }

  .carousel-item_phone_team.active {
    display: block;
  }

  .carousel-item.active {
    display: block;
  }

  .carousel-indicators {
    position: absolute;
    bottom: 1vw;
    width: 100%;
    text-align: center;
  }

  .carousel-indicators span {
    display: inline-block;
    width: 1.3vw;
    height: 0.3vw;
    background-color: white;
    margin: 0 0.1vw;
    border-radius: 1vw;
    cursor: pointer;
  }

  .carousel-indicators span.active {
    background-color: #00A2E9;
  }

  .model_title {
    display: flex;
    align-items: center;
    padding: 2vw 4vw;
    font-size: 1.5vw;
    justify-content: space-between;
  }

  .carousel_style {
    display: flex;
    align-items: center;
  }

  .carousel-button2 {
    padding: 0.5vw 0.6vw;
    border-radius: 50%;
    font-size: 1.5vw;
    border: 0.1px solid #00A2E9;
    color: #00A2E9;
    margin-right: 1.5vw;
    transition: 0.5s;
  }

  .carousel-button2:hover {
    background-color: #00A2E9;
    color: white;
  }

  /* 针对电脑端 */
  @media screen and (min-width: 1024px) {
    .phoneShow {
      display: none;
    }

    .phoneShow_btn {
      display: none;
    }

    .model2 .computerShow {
      /* border: 1px solid red; */
      padding: 0vw 4vw;
      margin-bottom: 4vw;
    }

    .team_slideShow {
      display: flex;
      /* overflow: hidden; */
      position: relative;
      width: 100%;
    }

    .team_slideShow_item {
      display: flex;
      /* transition: transform 0.5s ease; */
      width: 500%;
    }

    .team_slideShow_item_content {
      width: 20%;
      /* 每个元素占20%的宽度 */
      height: 15vw;
      /* margin-right: 1vw; */
      position: relative;
      opacity: 0.6;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }

    .team_slideShow_item_content:nth-child(2) {
      transform: scale(1.2);
      z-index: 22;
      opacity: 0.9;
    }

    .team_slideShow_item_content:nth-child(4) {
      transform: scale(1.2);
      z-index: 22;
      opacity: 0.9;
    }

    .team_slideShow_item_content.active_team {
      /* 高亮显示 */
      transform: scale(1.4);
      /* 放大效果 */
      z-index: 33;
      opacity: 1;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
    }

    .team_slideShow_item_title {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      padding: 1vw 0;
      color: white;
      font-size: 0.8vw;
      font-weight: 600;
      background-color: rgba(0, 0, 0, 0.3);
    }

    .model3 .computerShow {
      background-image: url(../assets/img7.jpeg);
      background-size: cover;
    }

    .proImg {
      width: 50%;
      height: 13vw;
      margin: 3vw auto 5vw auto;
    }

    .pro_computer {
      display: flex;
      overflow: hidden;
    }

    .pro_computer>div {
      flex: 1;
      height: 18vw;
      border: 0.1px solid #CDCDCD;
      border-top: none;
      position: relative;
    }

    .pro_computer>div:nth-child(1) {
      border: none;
      border-bottom: 0.1px solid #CDCDCD;
    }

    .pro_computer>div:nth-child(3) {
      border-left: none;
    }

    .pro_computer2>div:nth-child(1) {
      border: none;
      border-bottom: 0.1px solid #CDCDCD;
    }

    .pro_computer2>div:nth-child(3) {
      border-left: none;
    }

    .pro_computer2 {
      display: flex;
      overflow: hidden;
    }

    .pro_computer2>div {
      flex: 1;
      height: 18vw;
      border: 0.1px solid #CDCDCD;
      position: relative;
      border-top: none;
      border-bottom: none;
    }

    .hover-pro {
      background: linear-gradient(0deg, #00A2E9 0%, #FFFFFF 100%);
    }

    @keyframes hover_pro {
      0% {
        opacity: 0.5;
      }

      100% {
        opacity: 1;
      }
    }

    .pro_computer_title {
      background-color: rgba(0, 164, 235, 0.3);
      color: white;
      padding: 0.5vw 1.2vw;
      width: 6vw;
      font-size: 1.2vw;
      border-radius: 1vw;
      position: absolute;
      bottom: 5vw;
      left: 3vw;
      font-weight: bold;
    }

    .pro_computer>div:nth-child(1):hover .pro_computer_title1 {
      background-color: rgba(0, 164, 235, 0);
      animation: hover_pro_title 0.5s ease-in-out forwards;
    }

    .pro_computer>div:hover .proImg {
      animation: hover_pro_learnBtn 1s ease-in-out;
    }

    .pro_computer2>div:hover .proImg {
      animation: hover_pro_learnBtn 1s ease-in-out;
    }

    @keyframes hover_pro_title {
      0% {
        transform: translateY(0%);
      }

      100% {
        transform: translateY(-30%);
      }
    }

    .pro_computer>div:nth-child(2):hover .pro_computer_title2 {
      background-color: rgba(0, 164, 235, 0);
      animation: hover_pro_title 0.5s ease-in-out forwards;
    }

    .pro_computer>div:nth-child(3):hover .pro_computer_title3 {
      background-color: rgba(0, 164, 235, 0);
      animation: hover_pro_title 0.5s ease-in-out forwards;
    }

    .pro_computer2>div:nth-child(1):hover .pro_computer_title4 {
      background-color: rgba(0, 164, 235, 0);
      animation: hover_pro_title 0.5s ease-in-out forwards;
    }

    .pro_computer2>div:nth-child(2):hover .pro_computer_title5 {
      background-color: rgba(0, 164, 235, 0);
      animation: hover_pro_title 0.5s ease-in-out forwards;
    }

    .pro_computer_learnBtn {
      opacity: 0;
      transform: translateY(10%);
      position: absolute;
      bottom: 3vw;
      left: 5vw;
      color: white;
      width: 4vw;
      border-top: 1px solid white;
      font-size: 1vw;
      padding-top: 0.5vw;
    }

    .pro_computer>div:nth-child(1):hover .pro_computer_learnBtn1 {
      animation: hover_pro_learnBtn 0.5s ease-in-out forwards;
    }

    .pro_computer>div:nth-child(2):hover .pro_computer_learnBtn2 {
      animation: hover_pro_learnBtn 0.5s ease-in-out forwards;
    }

    .pro_computer>div:nth-child(3):hover .pro_computer_learnBtn3 {
      animation: hover_pro_learnBtn 0.5s ease-in-out forwards;
    }

    .pro_computer2>div:nth-child(1):hover .pro_computer_learnBtn4 {
      animation: hover_pro_learnBtn 0.5s ease-in-out forwards;
    }

    .pro_computer2>div:nth-child(2):hover .pro_computer_learnBtn5 {
      animation: hover_pro_learnBtn 0.5s ease-in-out forwards;
    }

    @keyframes hover_pro_learnBtn {
      0% {
        opacity: 0;
        transform: translateY(30%);
      }

      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .carousel_honor {
      position: relative;
      /* width: 100%; */
      overflow: hidden;
      padding: 0vw 4vw;
    }

    .carousel_honorStyle {
      display: flex;
      transition: transform 0.5s ease;
    }

   

    .carousel_item_honor {
      width: 20%;
      height: 20vw;
      /* 5 个项目一行，所以每个占 20% */
      padding: 10px;
      box-sizing: border-box;
    }

    .carousel_item_honor:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
      transition: 0.2s;
    }

    .carousel_honorStyle img {
      width: 100%;
      height: 16vw;
      display: block;
    }

    button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background-color: rgba(0, 0, 0, 0.0);
      color: #00A1E9;
      border: 0.1px solid #00A1E9;
      padding: 0.2vw 0.4vw;
      cursor: pointer;
      border-radius: 50%;
      font-size: 1.5vw;
    }

    .prev {
      left: 1vw;
    }

    .next {
      right: 1vw;
    }

    .honorText {
      margin-top: 0.5vw;
      /* margin-bottom: 5vw; */
      font-size: 0.9vw;
      color: #666666;
      font-weight: 600;
    }

    .model5 .computerShow {
      display: flex;
    }

    .model5 .computerShow>div {
      flex: 1;
      height: 25vw;
      margin-right: 2vw;
      overflow: hidden;
      border-radius: 1vw;
      position: relative;
    }

    .model5 .computerShow>div:nth-child(3) {
      display: flex;
      flex-direction: column;
      margin-right: 0vw;
      border-radius: 0vw;
    }

    .model5 .computerShow>div:nth-child(3)>div {
      height: 12vw;
      overflow: hidden;
      border-radius: 1vw;
      position: relative;
    }

    .model5 .computerShow>div:nth-child(3)>div:nth-child(1) {
      margin-bottom: 2vw;
    }

    .new_com {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 1vw 2vw;
      width: 100%;
      color: white;
      font-size: 0.8vw;
      font-weight: 600;
      background-color: rgba(0, 164, 235, 0.3);
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    .newImg_com:hover {
      scale: 1.1;
      transition: 1s;
    }

    .new_com>div {
      margin-right: 3vw;
    }

    .new_com>span {
      color: #CDCDCD;
    }











  }


  /* 针对手机端 */
  @media screen and (max-width: 1023px) {
    .model1_text {
      font-size: 2.8vw;
    }

    .model1_text>div:nth-child(2) {
      font-size: 2vw;
    }

    .model1_text>div:nth-child(2)>i {
      font-size: 1.8vw;
    }

    .carousel-indicators span {
      width: 3vw;
      height: 1vw;
      margin: 0 2vw;
    }

    .computerShow {
      display: none;
    }

    .computerShow_btn {
      display: none;
    }


    /*.carousel_phone {
      position: relative;
      width: 50%;
      margin: auto;
      overflow: hidden;
    }
 
    .carousel-container_phone {
      display: flex;
      transition: transform 0.5s ease;
    }

    .carousel-item_phone {
      height: 40vw;
      position: relative;
      border: 1px solid red;
    } */

    .team_title {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 2vw 0vw;
      background-color: rgba(0, 0, 0, 0.3);
      font-size: 2.4vw;
      color: white;
    }

    .model_title {
      font-size: 2.4vw;
    }

    .carousel-button2 {
      font-size: 2vw;
    }

    .pro_phoneList {
      display: flex;
      flex-wrap: wrap;
    }

    .pro_phoneList_item {
      position: relative;
      width: 49.2vw;
      height: 40vw;
      background: linear-gradient(0deg, #00A2E9 0%, #FFFFFF 100%);
      border-bottom: 3px solid #CDCDCD;
      border-right: 0.1px solid #CDCDCD;
      color: white;
      font-size: 2.8vw;
    }

    .pro_phoneList_item:nth-child(even) {
      border-right: none;
    }

    .pro_phoneList_item_img {
      position: absolute;
      bottom: 12vw;
      width: 50%;
      height: 50%;
      left: 35%;
      z-index: 1;
    }

    .pro_phoneList_item_text {
      position: absolute;
      bottom: 5vw;
      width: 50%;
      left: 18%;
      z-index: 2;
      text-align: left;
    }

    .pro_phoneList_item_text>div:nth-child(1) {
      margin-bottom: 2vw;
      font-size: 3.5vw;
    }

    .pro_phoneList_item_text>div:nth-child(2) {
      padding-top: 1vw;
      border-top: 0.1px solid white;
      width: 12vw;
    }

    .pro_phoneList_item:last-child>div {
      font-size: 3vw;
      background-color: rgba(0, 164, 235, 0.3);
      width: 50%;
      margin: auto;
      margin-top: 30%;
      padding: 3vw 0vw;
      border-radius: 10vw;
    }

    .model4_phoneShow {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }

    .carousel-button3 {
      border-radius: 50%;
      font-size: 2.5vw;
      border: 0.1px solid #00A2E9;
      color: #00A2E9;
      margin-right: 1.5vw;
      transition: 0.5s;
      margin: 0vw 8vw;
      height: 5vw;
      width: 5vw;
    }

    .carousel-button3>i {
      margin-top: 1.5vw;
    }

    .carouse2 {
      position: relative;
      width: 100%;
      overflow: hidden;
    }

    .carousel-container {
      display: flex;
      transition: transform 0.5s ease;
    }

    /* .carousel-item {
      min-width: 100%;
      display: none;
      height: 30vw;
    } */

    .carousel-item.active {
      display: block;
    }

    .honorText {
      margin-top: 2vw;
      margin-bottom: 5vw;
      font-size: 2.4vw;
    }

    .model4 {
      margin-bottom: 15vw;
    }

    .new_phoneShow {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10vw;
    }

    .new_phoneShow>div:nth-child(1) {
      width: 52.5vw;
      margin-right: 4vw;
      margin-bottom: 2vw;
    }

    .new_phoneShow>div:nth-child(2) {
      width: 42vw;
      margin-bottom: 2vw;
    }

    .new_phoneShow>div:nth-child(3) {
      width: 47vw;
      margin-right: 4.5vw;
    }

    .new_phoneShow>div:nth-child(4) {
      width: 47vw;
    }

    .new_model {
      position: relative;
      overflow: hidden;
      border-radius: 2vw;
      height: 30vw;
    }

    .newText {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 1vw 4vw;
      background-color: rgba(0, 164, 235, 0.3);
      color: white;
      text-align: left;
      line-height: 4vw;
      font-size: 2.4vw;
      padding-bottom: 3vw;
    }

    .newText>div {
      margin: 2vw 4vw;
    }

    .newTime {
      position: absolute;
      bottom: 1vw;
      right: 3vw;
      color: #CDCDCD;
      font-size: 2.4vw;
    }
  }

  @media screen and (max-width: 555px) {
    .pro_phoneList_item {
      width: 48.5vw;
    }
  }
</style>